import { render, staticRenderFns } from "./EUserAvatar.vue?vue&type=template&id=0213fbb6&"
import script from "./EUserAvatar.vue?vue&type=script&lang=js&"
export * from "./EUserAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports